import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  GroupOfficeResourcesLoadAction,
  GroupOfficeResourcesLoadFulfilledAction,
} from '../../domains/groupOfficeResources/actions.types';

import { GroupOfficeResources, GroupsOfficeResources } from './types';

export type GroupOfficeResourcesAction = GroupOfficeResourcesLoadAction;

const initialState: GroupsOfficeResources = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

type NormalizedFulfilledEntities = (
  action: GroupOfficeResourcesLoadFulfilledAction['payload']
) => Record<string, GroupOfficeResources>;
const normalizedFulfilledEntities: NormalizedFulfilledEntities = ({ groupId, officeResources }) => ({
  [groupId]: {
    id: groupId,
    officeResources: officeResources ?? undefined,
  },
});

const reducer: Reducer<GroupsOfficeResources, GroupOfficeResourcesAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_OFFICE_RESOURCES.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_OFFICE_RESOURCES.LOAD_FULFILLED':
      return moveToFulfilled(state, normalizedFulfilledEntities(action.payload));
    case 'GROUP_OFFICE_RESOURCES.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    default:
      return state;
  }
};

export default reducer;
